'use strict';

module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./~/ng2-charts/~/chart.js/src/charts/Chart.Bar.js
// module id = 512
// module chunks = 55